import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles({
    divAluno: {
        border: '1px solid black',
        padding: '15px',
        marginBottom: '8px',
        borderRadius: '20px',
    }
});

const AlunoCard = ({ aluno }) => {
    const classes = useStyles();
    return (
        <div className={classes.divAluno}>
            <Typography>
                {aluno.nome}
            </Typography>
        </div>
    );
}

export default AlunoCard;